import { useEffect, useState } from 'react';

export function useNoInteractionsFadeOut(timeoutMs: number) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        const handleInteraction = () => {
            clearTimeout(timeout);
            setIsVisible(true);
            timeout = setTimeout(() => {
                setIsVisible(false);
            }, timeoutMs);
        };

        window.addEventListener('mousemove', handleInteraction);
        window.addEventListener('click', handleInteraction);

        return () => {
            window.removeEventListener('mousemove', handleInteraction);
            window.removeEventListener('click', handleInteraction);
        };
    }, [timeoutMs]);

    return isVisible;
}
